import { FolderFilled } from "@ant-design/icons";
import { Modal } from "antd";
import React, { Component } from "react";
import { Alert } from "rsuite";
import { Context } from "../Context";
import { Loader } from "../components";
import constants from "../constants";
import RbacModal from "./rbacmodal";

/**
 *
 * @param props This is an immutable object which holds the references to the parent component
 * @description This method has been designed to simplify the rendering
 *              of Image Uploader Modal and make it more reusable
 */
export default class SelectedImageAndFolderModal extends Component {
	static contextType = Context;
	constructor(props) {
		super(props);
		this.state = {
			folder: "",
			openFolder: false,
			loading: false,
		};
	}

	componentDidMount() {
		this.setState({ folder: this.context.contextState.default_folder });
	}

	handleImageModalOK = () => {
		const selected_folder = this.state.folder;
		const image_path = !this.props.isFB ? this.props.selectedImageFile : "";
		if (!selected_folder || !selected_folder.length > 0) {
			Alert.error("Folder is mandatory.", constants.alertDuration);
		} else {
			if (!this.props.isFB) {
				this.context.handleUploadedFiles(
					image_path,
					this,
					selected_folder,
				);
			} else {
				this.props.selectedFolderName(selected_folder);
			}
			this.props.onCancel();
		}
	};

	done = (url) => {
		this.props.done(url);
	};

	openRbacFolder = () => {
		this.setState({ openFolder: true });
	};

	closeRbacFolder = () => {
		this.setState({ openFolder: false });
	};

	selectedFolder = (val) => {
		this.setState({ folder: val[0] });
	};

	render() {
		return (
			<>
				<Loader loading={this.state.loading} />
				<Modal
					open={this.props.visible}
					onOk={this.handleImageModalOK}
					onCancel={this.props.onCancel}
				>
					<div className="image-container image-container-unlayer">
						<div className="field">
							<div className="field-box">
								<span>
									<p>
										<b>File Selected: </b>
										{this.props.isFB && this.props.selectedImageFile
											? this.props.selectedImageFile.join(", ")
											: this.props.selectedImageFile?.file?.name
												? this.props.selectedImageFile.file.name
												: ""}
									</p>
									{this.context.contextState.is_folder_enabled == true ? (
										<span
											style={{ display: "flex" }}
											onClick={this.openRbacFolder}
											onKeyUp={(e) => {
												if (e.key === "Enter") {
													this.openRbacFolder();
												}
											}}
										>
											<FolderFilled
												style={{
													fontSize: "30px",
													cursor: "pointer",
													color: "#6564eb",
												}}
											/>
											<span
												style={{
													fontSize: "12px",
													fontWeight: "bold",
													paddingLeft: "8px",
													paddingTop: "12px",
												}}
											>
												{this.context.contextState.default_folder
													? this.state.folder === ""
														? `${
																this.context.contextState.key_mapping[
																	this.context.contextState.default_folder
																]
															}`
														: `${this.context.contextState.key_mapping[this.state.folder]}`
													: "Select Folder"}
											</span>
										</span>
									) : null}
								</span>
							</div>
						</div>

						<RbacModal
							onCancel={this.closeRbacFolder}
							openForm={this.state.openFolder}
							selectedFolder={this.selectedFolder}
							folders_accessible={this.context.contextState.folders_accessible}
							folder_structure={this.context.contextState.folder_structure}
							default_folder={this.context.contextState.default_folder}
						/>
					</div>
				</Modal>
			</>
		);
	}
}
